<template>
  <van-config-provider :theme-vars="themeVars">
    <router-view v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <keep-alive :include="keepAliveList">
          <component :is="Component" :key="route.path" />
        </keep-alive>
      </transition>
    </router-view>
  </van-config-provider>
</template>

<script setup lang="ts">
import type { ConfigProviderThemeVars } from 'vant'
import routes from '@/router/routes'

const themeVars: ConfigProviderThemeVars = {
  primaryColor: '#eb3c3c',
  buttonPrimaryBackground: '#eb3c3c',
  buttonPrimaryBorderColor: '#eb3c3c',
}

/** 需要缓存的页面组件名，取 meta.keepAlive 为 true 的路由 */
const keepAliveList = routes
  .filter((route) => route.meta?.keepAlive && route.name)
  .map((route) => String(route.name))
</script>
